import { useState, useEffect } from 'react'
import { Container } from '@ui/wrapper'
import {
  ServicesWrapper,
  StyledText,
  TitleWrapper,
  LogoWrapper,
  CirclesWrapper,
  Subpoints
} from './style'
import SectionTitle from '@ui/section-title'
import Row from 'react-bootstrap/Row'
import LogoSvg from '../../../assets/images/logo/dark-logo-2.svg'
import './style.css'

const AufgabenUndZieleArea = ({ data, data2, ...rest }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null)

  const handleTouchStart = (index) => {
    setHoveredIndex(index)
  }

  const handleOutsideClick = (event) => {
    if (!event.target.closest('.subpoints-touch')) {
      setHoveredIndex(null)
    }
  }

  useEffect(() => {
    document.addEventListener('touchstart', handleOutsideClick)
    return () => {
      document.removeEventListener('touchstart', handleOutsideClick)
    }
  }, [])

  return (
    <ServicesWrapper {...rest}>
      <Container>
        <SectionTitle
          mb={['15px', null, '20px']}
          subtitle={data.section_title?.subtitle}
          title={data.section_title?.title}
        />
        <div>
          <Row
            style={{ display: 'flex', justifyContent: 'center' }}
            xs={2}
            md={5}
          >
            <LogoWrapper>
              <img src={LogoSvg} alt="BSW" />
            </LogoWrapper>
          </Row>
          <CirclesWrapper>
            {data?.items?.map((item, index) => (
              <div
                key={index}
                style={{ position: 'relative' }}
                className={hoveredIndex === index ? 'subpoints-touch' : ''}
              >
                <TitleWrapper
                  key={index}
                  data-text={item?.title}
                  data-position={index % 2 === 0 ? 'left' : 'right'}
                >
                  <div
                    className="title-text"
                    onTouchStart={() => handleTouchStart(index)}
                  >
                    {item?.title}
                  </div>
                </TitleWrapper>
                <Subpoints
                  className="subpoints"
                  data-position={index % 2 === 0 ? 'left' : 'right'}
                >
                  <ul style={{ paddingLeft: '20px', listStyleType: 'disc' }}>
                    {item?.texts?.map((subItem, subIndex) => (
                      <li
                        key={subIndex}
                        dangerouslySetInnerHTML={{
                          __html: subItem.content
                        }}
                      />
                    ))}
                  </ul>
                </Subpoints>
              </div>
            ))}
          </CirclesWrapper>
        </div>
        <SectionTitle
          mb={['15px', null, '20px']}
          mt={['60px', null, '70px']}
          subtitle={data2.section_title?.subtitle}
          title={data2.section_title?.title}
        />
        {data2.texts?.[0] && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: data2.texts[0].content
            }}
          />
        )}
        <StyledText>
          <ul style={{ listStyleType: 'disc', marginLeft: '30px' }}>
            {data2.items?.map((item, subIndex) => (
              <li
                key={subIndex}
                dangerouslySetInnerHTML={{
                  __html: item.texts[0].content
                }}
              />
            ))}
          </ul>
        </StyledText>
      </Container>
    </ServicesWrapper>
  )
}

export default AufgabenUndZieleArea
